

const timeFormatSecond = (value) => {
        if (value) {
            value = +value * (value.toString().length === 10 ? 1000 : 1);

            let date = new Date(value);

            let year = date.getFullYear(),
                month = date.getMonth() + 1,
                day = date.getDate(),
                hour = date.getHours(),
                minute = date.getMinutes(),
                second = date.getSeconds();

            return [year, month < 10 ? '0' + month : month, day < 10 ? '0' + day : day].join('-') + ' ' + 
                [hour < 10 ? '0' + hour : hour, minute < 10 ? '0' + minute : minute, second < 10 ? '0' + second : second].join(':');
        }

        return value || '';
    }
    const timeFormatFive = (value) => {
        if (value) {
            value = +value * (value.toString().length === 10 ? 1000 : 1);

            let date = new Date(value);

            let year = date.getFullYear(),
                month = date.getMonth() + 1,
                day = date.getDate(),
                hour = date.getHours(),
                minute = date.getMinutes(),
                second = date.getSeconds();

            return [year, month < 10 ? '0' + month : month, day < 10 ? '0' + day : day].join('.') + ' ' + 
                [hour < 10 ? '0' + hour : hour, minute < 10 ? '0' + minute : minute, second < 10 ? '0' + second : second].join(':');
        }

        return value || '';
    }
    
const timeFormat = (value) => {
        if (value) {
            value = +value * (value.toString().length === 10 ? 1000 : 1);

            let date = new Date(value);

            let year = date.getFullYear(),
                month = date.getMonth() + 1,
                day = date.getDate(),
                hour = date.getHours(),
                minute = date.getMinutes();

            return [year, month < 10 ? '0' + month : month, day < 10 ? '0' + day : day].join('-');
        }

        return value || '';
    }

    const timeFormatPoint = (value) => {
        if (value) {
            value = +value * (value.toString().length === 10 ? 1000 : 1);

            let date = new Date(value);

            let year = date.getFullYear(),
                month = date.getMonth() + 1,
                day = date.getDate(),
                hour = date.getHours(),
                minute = date.getMinutes();

            return [year, month < 10 ? '0' + month : month, day < 10 ? '0' + day : day].join('.');
        }

        return value || '';
    }

const distanceFormat = (value) => {
        if (value > 1000){
            return value = parseFloat(value/1000).toFixed(1)+'km'
        }
        if(value < 1000){
            return value = parseFloat(value).toFixed(0)+'m'
        }
    }

    const timeFormaTthird = (value) => {
        if (value) {
            value = +value * (value.toString().length === 10 ? 1000 : 1);

            let date = new Date(value);

            let hour = date.getHours(),
                minute = date.getMinutes(),
                second = date.getSeconds();

            return [hour < 10 ? '0' + hour : hour, minute < 10 ? '0' + minute : minute,].join(':');
        }

        return value || '';
    }

    const timeFormaTfour = (value) => {
        if (value) {
            value = +value * (value.toString().length === 10 ? 1000 : 1);

            let date = new Date(value);

            let hour = date.getHours(),
                minute = date.getMinutes(),
                second = date.getSeconds();

            return  [hour < 10 ? '0' + hour : hour, minute < 10 ? '0' + minute : minute, second < 10 ? '0' + second : second].join(':');
        }

        return value || '';
    }

    const doubleToFixed = (value, fixed) => {
        if (value) {
            return value.toFixed(fixed)
        }
        return '';
    }




export default {
    timeFormatSecond,
    timeFormat,
    distanceFormat,
    timeFormaTthird,
    timeFormaTfour,
    timeFormatPoint,
    doubleToFixed,
    timeFormatFive
}



// WEBPACK FOOTER //
// ./src/filter/timeFormat.js